import { FC } from 'react';
import { Line, ReferenceArea } from 'recharts';
import { MetricChartFrame } from './MetricChartFrame';
import { HighlightDot } from './HighlightDot';
import { ACWR_MIN, ACWR_MAX, isAcwrOutOfRange } from '../../effort/useAthleteEffort';
import { MetricHistoryPoint } from '../useMetricHistory';

interface Props {
  data: MetricHistoryPoint[];
  color: string;
  /** YYYY-MM-DD — giorno da evidenziare (cella cliccata) */
  highlightDate?: string | null;
  height?: number;
}

/**
 * Chart ACWR — linea + fascia ottimale 0.80–1.30 evidenziata, stile
 * `EffortAcwrChart` (drill-down atleta tab Sforzo).
 */
export const MetricAcwrChart: FC<Props> = ({ data, color, highlightDate, height }) => {
  const renderDot = (dotProps: any) => (
    <HighlightDot
      {...dotProps}
      color={color}
      highlightDate={highlightDate}
      isOutOfRange={isAcwrOutOfRange}
    />
  );

  return (
    <MetricChartFrame
      data={data}
      height={height}
      highlightDate={highlightDate}
      highlightColor={color}
      as="line"
      yAxisDomain={[0, 'auto']}
      yAxisTickFormatter={(v) => Number(v).toFixed(1)}
      tooltipFormatter={(value) => [Number(value).toFixed(2), 'ACWR']}
      beforeGrid={
        <ReferenceArea
          y1={ACWR_MIN}
          y2={ACWR_MAX}
          fill="var(--c-success)"
          fillOpacity={0.12}
          ifOverflow="extendDomain"
        />
      }
    >
      <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2} dot={renderDot} />
    </MetricChartFrame>
  );
};
